const clickIdCookieName = 'impact_clickid'
const irpidCookieName = 'impact_irpid'
const hasUTTCookies = () => document.cookie.includes(clickIdCookieName) || document.cookie.includes(irpidCookieName)
const setImpactUTTCookies = () => {
    // Store referral tracking cookies
    const queryParams = new URLSearchParams(window.location.search.slice(1))
    const ninetyDaysInSeconds = 60 * 60 * 24 * 90
    const irpid = queryParams.get('irpid') || queryParams.get('mpid')

    if (irpid) {
        document.cookie = `${irpidCookieName}=${irpid}; max-age=${ninetyDaysInSeconds}; domain=${window.location.hostname}; Secure; path=/`
    }

    ire('generateClickId', (clickId) => {
        const clickIdValue = clickId || queryParams.get('irclickid') || getCookieValue(clickIdCookieName)
        document.cookie = `${clickIdCookieName}=${clickIdValue}; max-age=${ninetyDaysInSeconds}; domain=${window.location.hostname}; Secure; path=/`
    })
}
const enrichMarketoFormWithImpactUTT = (htmlForm) => {
    if (!hasUTTCookies()) {
        console.error('No impact UTT cookies')
    }

    // Get form input fields
    const irpidField = htmlForm.querySelector(`input[name="MPID__c"]`)
    const clickIdField = htmlForm.querySelector(`input[name="ClickID__c"]`)
    const customerIdField = htmlForm.querySelector(`input[name="CustomerID__c"]`)

    if (irpidField) {
        irpidField.value = getCookieValue(irpidCookieName)
    }
    if (clickIdField) {
        clickIdField.value = getCookieValue(clickIdCookieName)
    }
    if (customerIdField) {
        customerIdField.value = crypto.randomUUID()
    }
}

(function (a, b, c, d, e, f, g) {
    e['ire_o'] = c;
    e[c] = e[c] || function () {
        (e[c].a = e[c].a || []).push(arguments)
    };
    f = d.createElement(b);
    g = d.getElementsByTagName(b)[0];
    f.async = 1;
    f.src = a;
    f.onload = () => {
        ire('identify', {customerId: '', customerEmail: '', customProfileId: ''})
        setImpactUTTCookies()
    }
    g.parentNode.insertBefore(f, g);
})('https://utt.impactcdn.com/A6261824-553b-44c1-9e5b-042f615247db1.js', 'script', 'ire', document, window);
